import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { SolutionIntro } from '../components/SolutionIntro';
import { Volumes } from '../components/Volumes';
import { InsidePreview } from '../components/InsidePreview';
import { Bonuses } from '../components/Bonuses';
import { Benefits } from '../components/Benefits';
import { SpecialOffer } from '../components/SpecialOffer';
import { Guarantee } from '../components/Guarantee';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { LastChance } from '../components/LastChance';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen bg-navy-950 font-inter text-white selection:bg-gold-500/30 selection:text-gold-200" data-id="element-293">
      <Hero data-id="element-294" />
      <PainPoints data-id="element-295" />
      <SolutionIntro data-id="element-296" />
      <Volumes data-id="element-297" />
      <InsidePreview data-id="element-298" />
      <Bonuses data-id="element-299" />
      <Benefits data-id="element-300" />
      <SpecialOffer data-id="element-301" />
      <Guarantee data-id="element-302" />
      <Testimonials data-id="element-303" />
      <FAQ data-id="element-304" />
      <LastChance data-id="element-305" />
      <Footer data-id="element-306" />
    </main>;
}